import { createActions, createReducer } from "reduxsauce";
import Immutable from "seamless-immutable";

export const { Types, Creators } = createActions({
	setUsuario: ["usuario"],
	clearUsuario: []
});

const auth = {
	usuario: {
		name: null
	}
};

const INITIAL_STATE = Immutable(Object.assign({}, auth));

const setUsuario = (state = INITIAL_STATE, action) =>
	state.merge({
		usuario: action.usuario
	});

const clearUsuario = (state = INITIAL_STATE) => state.merge(auth);

export default createReducer(INITIAL_STATE, {
	[Types.SET_USUARIO]: setUsuario,
	[Types.CLEAR_USUARIO]: clearUsuario
});
